import {Pipe, PipeTransform} from '@angular/core';
import {DirectusTranslation} from './models/translation';

@Pipe({
  name: 'directusTranslation',
})
export class DirectusTranslationPipe implements PipeTransform {
  transform(
    translations?: DirectusTranslation[],
    currentLang?: string,
    fallback?: string,
    field = 'name',
  ): string | undefined {
    if (!currentLang || !Array.isArray(translations) || translations?.length === 0) return fallback;
    const translation = translations?.find((t) => t.language === currentLang);
    const translatedValue = translation?.[field as keyof DirectusTranslation] as string;
    return (
      translatedValue ||
      (translations?.[0]?.[field as keyof DirectusTranslation] as string) ||
      fallback
    );
  }
}
